var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.94,
    height: 14.062,
    viewBox: "0 0 10.94 14.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M126.314.849h2.35v.4h.849V.793A.794.794,0,0,0,128.72,0h-2.462a.794.794,0,0,0-.793.793v.451h.849Zm0,0",
    transform: "translate(-122.019 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M48.832,167.75H40.864a.374.374,0,0,0-.373.4l.666,8.237a.885.885,0,0,0,.881.814h5.618a.885.885,0,0,0,.881-.814l.666-8.237A.374.374,0,0,0,48.832,167.75Zm-6.039,8.576h-.027a.424.424,0,0,1-.423-.4l-.417-6.762a.424.424,0,1,1,.847-.052l.417,6.762A.424.424,0,0,1,42.793,176.326Zm2.484-.424a.424.424,0,0,1-.849,0v-6.762a.424.424,0,1,1,.849,0Zm2.493-6.737-.4,6.762a.424.424,0,0,1-.423.4h-.025a.424.424,0,0,1-.4-.449l.4-6.762a.424.424,0,1,1,.847.05Zm0,0",
    transform: "translate(-39.378 -163.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M10.922,77.415l-.279-.836a.54.54,0,0,0-.512-.369H.809A.54.54,0,0,0,.3,76.58l-.279.836a.351.351,0,0,0,.332.461H10.59a.346.346,0,0,0,.185-.054A.35.35,0,0,0,10.922,77.415Zm0,0",
    transform: "translate(-0.001 -74.118)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c4af1a273307d79279d897969b8c809b.svg";
export { ForwardRef as ReactComponent };